// iter9.4: assistente de voz Babita (Jarvis-style) + resumo ao navegar + perguntas habilitadas
// STT: Web Speech API (Chrome/Edge, pt-BR)
// TTS: Piper Cadu via /AssistenteVozFalar (servidor IABabita)
// Comandos locais: navegacao, busca, logout, 5 perguntas (alertas/bloqueados/rotinas/conexao/latencia)
// Resumo ao navegar: toggle separado em /Configuracoes

import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConsultaAlertas, ConsultaMonitor, ConsultaLogins, ConsultaConexoes, ConsultaRotinas, ConsultaInternas, ConsultaPermissoes, ConsultaConstrutor, ConsultaTelegram, ConsultaArquivos, ConsultaLogs, MontaPanorama } from '../lib/api';
import { falar, silenciar, vozBus, destravarAudioMobile } from '../lib/voz';
import { Buscar as PD_Buscar, Executar as PD_Executar } from '../personalizados/PerguntarDados/api';

const ROTAS = [
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+|abrir\s+a\s+)?dashboard/i, to: '/Dashboard', label: 'Dashboard' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?alertas?/i, to: '/Alertas', label: 'Alertas' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?logs?/i, to: '/Logs', label: 'Logs' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?monitor/i, to: '/TI/Monitor', label: 'Monitor' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?crontab/i, to: '/Crontab', label: 'Crontab' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?(internas?|p[aá]ginas?)/i, to: '/Internas', label: 'Páginas Internas' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?(configura|ajustes|preferenc)/i, to: '/Configuracoes', label: 'Configurações' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?(arquivos|samba|fileserver)/i, to: '/Arquivos', label: 'Arquivos' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?(t\.?\s*i\.?\s+)?(logins?|usu[aá]rios?)/i, to: '/TI/Logins', label: 'TI · Logins' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?(t\.?\s*i\.?\s+)?(permiss)/i, to: '/TI/Permissoes', label: 'TI · Permissões' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?(t\.?\s*i\.?\s+)?(bancos?|conex)/i, to: '/TI/Bancos', label: 'TI · Bancos' },
    { regex: /^(ir(?:\s+para)?\s+|abrir\s+|vai\s+(?:para|pra)\s+|abre\s+|mostrar\s+)?(t\.?\s*i\.?\s+)?(telegram)/i, to: '/TI/Telegram', label: 'TI · Telegram' },
];

// telas onde o botão não aparece: no Mapa Babita ele ficava por cima dos controles do mapa
const SEM_BOTAO = ['/personalizados/mapa-babita'];

const LABEL_ROTA = {
    '/Dashboard': 'Dashboard',
    '/Crontab': 'Crontab',
    '/Internas': 'Páginas Internas',
    '/Arquivos': 'Arquivos',
    '/Logs': 'Logs e Histórico',
    '/Alertas': 'Alertas',
    '/Configuracoes': 'Configurações',
    '/TI/Logins': 'Logins e Usuários',
    '/TI/Permissoes': 'Permissões',
    '/TI/Bancos': 'Conexões de Banco',
    '/TI/Construtor': 'Construtor de API',
    '/TI/Telegram': 'Telegram',
    '/TI/Monitor': 'Monitor de Requisições',
};

const SUGESTOES = [
    { grupo: 'Navegar', label: 'Dashboard',       cmd: 'dashboard' },
    { grupo: 'Navegar', label: 'Alertas',         cmd: 'alertas' },
    { grupo: 'Navegar', label: 'Monitor',         cmd: 'monitor' },
    { grupo: 'Navegar', label: 'Crontab',         cmd: 'crontab' },
    { grupo: 'Buscar',  label: 'Buscar rotinas',  cmd: 'buscar rotinas' },
    { grupo: 'Buscar',  label: 'Buscar erros',    cmd: 'buscar erro' },
    { grupo: 'Perguntas', label: 'Tem alerta crítico agora?',          cmd: 'tem alerta critico agora' },
    { grupo: 'Perguntas', label: 'Quem está bloqueado?',               cmd: 'quem esta bloqueado' },
    { grupo: 'Perguntas', label: 'Rotinas que falharam hoje',          cmd: 'rotinas que falharam hoje' },
    { grupo: 'Perguntas', label: 'PG_DEMO está conectando?',           cmd: 'pg demo esta conectando' },
    { grupo: 'Perguntas', label: 'Quanto demorou a última requisição?', cmd: 'quanto demorou a ultima requisicao' },
];

const DICIONARIO = [
    [/\babita\b/gi, 'babita'],
    [/\bsanba\b|\bsamra\b/gi, 'samba'],
    [/\bcronta\b|\bcron taby?\b/gi, 'crontab'],
    [/\bp[eê]g[uú] demo?\b|\bp[eê] g[eê] demo?\b/gi, 'pg demo'],
    [/\boracle?\s*sk[hé]\b/gi, 'oracle skh'],
    [/\bt[eê]\s*i\b/gi, 'ti'],
    [/\b(logim|loguin)\b/gi, 'login'],
    [/\b(deshboar?d?)\b/gi, 'dashboard'],
    [/\b(monit[oô]rar?)\b/gi, 'monitor'],
    [/\b(rotin[ae]?s?)\b/gi, 'rotinas'],
    [/\b(t[eé]l[eé]gram)\b/gi, 'telegram'],
];
function aplicaDicionario(t) { let s = t; for (const [re, rep] of DICIONARIO) s = s.replace(re, rep); return s; }

// desligado por padrão (23/10/2026): só liga para quem ativar em Configurações
function vozAtiva()        { try { return localStorage.getItem('centralbabita.voz.ativo')   === 'true'; } catch { return false; } }
function avisosAtivos()    { try { return localStorage.getItem('centralbabita.voz.avisos')  !== 'false'; } catch { return false; } }
function resumosAtivos()   { try { return localStorage.getItem('centralbabita.voz.resumo')  !== 'false'; } catch { return false; } }

const SpeechRec = typeof window !== 'undefined' ? (window.SpeechRecognition || window.webkitSpeechRecognition) : null;

// =============================================================================
// PERGUNTAS — respondem usando endpoints existentes (sem LLM).
// Cada handler devolve uma string para o Cadu falar.
// =============================================================================
async function respAlertasCriticos() {
    const a = await ConsultaAlertas({});
    if (!Array.isArray(a)) return 'Não consegui consultar os alertas.';
    const err = a.filter(x => x.severidade === 'err').length;
    if (err === 0) return 'Nenhum alerta crítico no momento.';
    if (err === 1) return `Há 1 alerta crítico pendente: ${(a.find(x=>x.severidade==='err').titulo || '').slice(0,120)}.`;
    return `Há ${err} alertas críticos pendentes. O mais recente: ${(a.find(x=>x.severidade==='err').titulo || '').slice(0,120)}.`;
}
async function respBloqueados() {
    const r = await ConsultaLogins({});
    if (r && r.Error) return 'Não consegui consultar os logins. Veja se você tem permissão de TI.';
    const lista = Array.isArray(r) ? r : (r?.users || []);
    const bloq = lista.filter(u => !u.ativo);
    if (bloq.length === 0) return 'Nenhum usuário bloqueado no momento.';
    if (bloq.length === 1) return `1 usuário bloqueado: ${bloq[0].nome || bloq[0].email}.`;
    const nomes = bloq.slice(0, 3).map(u => u.nome || u.email).join(', ');
    return `${bloq.length} usuários bloqueados. Os primeiros: ${nomes}.`;
}
async function respRotinasFalharam() {
    const m = await ConsultaMonitor({ limit: 500 });
    if (!m || !Array.isArray(m.eventos)) return 'Não consegui consultar o monitor.';
    const hoje = new Date(); hoje.setHours(0,0,0,0);
    const falhas = m.eventos.filter(e => {
        if (!(e.path === '/ExecutaRotina' || e.path === '/scheduler-tick')) return false;
        if (!(e.erro || e.status >= 400)) return false;
        const ts = e.ts ? new Date(e.ts) : null;
        return ts && ts >= hoje;
    });
    if (falhas.length === 0) return 'Nenhuma rotina falhou hoje.';
    if (falhas.length === 1) {
        const nome = falhas[0].payload?.nome || falhas[0].payload?.id || 'rotina';
        return `1 rotina falhou hoje: ${nome}.`;
    }
    return `${falhas.length} rotinas falharam hoje.`;
}
async function respValidacaoConexao(prefixo) {
    const r = await ConsultaConexoes({});
    const lista = r?.conexoes || [];
    const c = lista.find(x => x.prefixo.toUpperCase() === prefixo.toUpperCase());
    if (!c) return `Não encontrei a conexão ${prefixo}.`;
    if (!c.validacao) return `${prefixo} ainda não foi testada. Vá em Conexões de Banco e clique Testar.`;
    if (c.validacao.ok) return `${prefixo} está conectando. Último teste em ${c.validacao.latency_ms} milissegundos.`;
    return `${prefixo} está com falha: ${(c.validacao.err || '').slice(0,150)}.`;
}
async function respUltimaLatencia() {
    const m = await ConsultaMonitor({ limit: 1 });
    if (!m || !Array.isArray(m.eventos) || !m.eventos.length) return 'Sem chamadas registradas no monitor.';
    const e = m.eventos[0];
    return `Última requisição: ${e.method} ${e.path}, retornou ${e.status} em ${e.latency_ms} milissegundos.`;
}

// =============================================================================
// PERGUNTE PRO BABITO — fallback pro catalogo da tela "Perguntar aos Dados" quando
// nenhum comando local casou. Busca (BM25+sinonimos, sem IA) -> mostra OPCOES (chips) ->
// usuario clica -> executa a analise (SQL/API ja cadastrado, com escopo/permissao do
// proprio usuario) -> fala um resumo do resultado. Sem LLM (ver docs/ASSISTENTE_VOZ.md
// pro fallback conversacional futuro; isto aqui reusa o catalogo ja existente).
// =============================================================================
function usuarioAtual() { try { return JSON.parse(localStorage.getItem('centralbabita.user') || 'null'); } catch { return null; } }

function ehDataIso(v) { return typeof v === 'string' && /^\d{4}-\d{2}-\d{2}([T ]|$)/.test(v); }

// Formata uma data ISO (ex.: "2026-03-20T03:00:00.000Z") como "20/03/2026" (so acrescenta
// hora quando ela nao e meia-noite) -- falar a string ISO crua fica incompreensivel em voz.
function fmtDataVoz(v) {
    try {
        const d = new Date(v);
        if (isNaN(d.getTime())) return String(v);
        // So a data (dd/mm/aaaa), sem hora: colunas de data no catalogo vem de tipo DATE do
        // Postgres, que o driver serializa como meia-noite UTC-3 -> aparece como "T03:00:00.000Z"
        // (fuso de Brasilia). Mostrar a hora aqui seria mostrar esse artefato, nao um horario real.
        const dia = String(d.getUTCDate()).padStart(2, '0');
        const mes = String(d.getUTCMonth() + 1).padStart(2, '0');
        const ano = d.getUTCFullYear();
        return `${dia}/${mes}/${ano}`;
    } catch (_) { return String(v); }
}

function fmtNumVoz(v) {
    if (v == null || v === '') return '';
    const n = Number(String(v).replace(',', '.'));
    if (!isFinite(n)) return String(v);
    return n.toLocaleString('pt-BR', { maximumFractionDigits: 2 });
}

// Despacha pro formatador certo (data x numero) -- usado em qualquer valor de coluna lido do
// catalogo, que pode ser data (ISO), numero ou texto.
function fmtValorVoz(v) { return ehDataIso(v) ? fmtDataVoz(v) : fmtNumVoz(v); }

// Monta uma frase curta a partir do resultado de PD_Executar (colunas+rows), sem IA:
// 1 linha -> fala coluna:valor de cada coluna; varias linhas -> fala quantidade + resumo dos
// 3 primeiros resultados (datas e valores formatados, nao a string crua do banco).
function resumirResultadoParaFala(r, tituloItem) {
    if (!r) return 'Não consegui obter o resultado.';
    if (r.Error) return r.Error;
    if (r.bloqueado || r.needs_review || r.indisponivel) return r.Error || 'Essa análise não está disponível aqui.';
    const cols = r.colunas || [];
    const rows = r.rows || [];
    if (!rows.length) return `${tituloItem ? tituloItem + '. ' : ''}Não encontrei dados para esse período.`;
    const nomeCol = (c) => String((c && (c.label || c.nome)) || '');
    if (rows.length === 1) {
        const linha = rows[0];
        const partes = cols.slice(0, 4).map(c => `${nomeCol(c)} ${fmtValorVoz(linha[c.nome])}`).filter(p => p.trim());
        return `${tituloItem ? tituloItem + '. ' : ''}${partes.join(', ')}.`;
    }
    // heuristica: no catalogo a metrica principal costuma ser a ULTIMA coluna do SELECT
    // (ex.: vendedora,loja,documentos,bruto -- "bruto" e o que importa pra "quem vendeu mais").
    const colX = cols[0] || {}, colY = cols[cols.length - 1] || cols[0] || {};
    const top = rows.slice(0, 3);
    const resumoTop = top.map(l => `${fmtValorVoz(l[colX.nome])}: ${fmtValorVoz(l[colY.nome])}`).join('; ');
    const rotulo = top.length > 1 ? `Os ${top.length} primeiros` : 'O primeiro';
    return `${tituloItem ? tituloItem + '. ' : ''}${rows.length} resultados. ${rotulo} (${nomeCol(colY)}): ${resumoTop}.`;
}

// Match das perguntas (texto livre ou click no chip)
function matchPergunta(cmd) {
    if (/alerta.*crit|critic.*alerta|tem.*alerta|alerta.*agora/i.test(cmd)) return respAlertasCriticos;
    if (/(quem.*bloqueado|usuario.*bloqueado|bloqueados?$|listar.*bloqueado)/i.test(cmd)) return respBloqueados;
    if (/rotina.*falh|falh.*rotin|rotina.*hoje/i.test(cmd)) return respRotinasFalharam;
    if (/quanto.*demorou|ultima.*requis|latencia.*ultima/i.test(cmd)) return respUltimaLatencia;
    // validacao de conexao: "pg demo conectando", "oracle skh conexao", etc.
    const mPg = cmd.match(/\b(pg[_\s-]?[a-z0-9]+)\s+(esta\s+)?(conectando|conexao|funciona)/i);
    const mOr = cmd.match(/\b(oracle[_\s-]?[a-z0-9]+)\s+(esta\s+)?(conectando|conexao|funciona)/i);
    if (mPg) return () => respValidacaoConexao(mPg[1].replace(/[\s-]/g, '_').toUpperCase());
    if (mOr) return () => respValidacaoConexao(mOr[1].replace(/[\s-]/g, '_').toUpperCase());
    return null;
}

// =============================================================================
// RESUMOS POR ROTA (falados ao navegar)
// =============================================================================
async function resumoDe(pathname) {
    try {
        if (pathname === '/Alertas') {
            const a = await ConsultaAlertas({});
            if (Array.isArray(a)) {
                const err = a.filter(x => x.severidade === 'err').length;
                if (a.length === 0) return 'Alertas. Nenhum pendente.';
                return `Alertas. ${a.length} pendentes${err ? `, ${err} críticos` : ''}.`;
            }
        }
        if (pathname === '/TI/Monitor') {
            const m = await ConsultaMonitor({ limit: 200 });
            const s = m?.stats || {};
            return `Monitor. ${s.total || 0} chamadas, ${s.erros || 0} com erro, latência mediana ${s.p50 || 0} milissegundos.`;
        }
        if (pathname === '/TI/Bancos') {
            const r = await ConsultaConexoes({});
            const c = r?.conexoes || [];
            const ok = c.filter(x => x.validacao?.ok).length;
            return `Conexões de banco. ${c.length} cadastradas, ${ok} validadas.`;
        }
        if (pathname === '/TI/Logins') {
            const u = await ConsultaLogins({});
            const lista = Array.isArray(u) ? u : (u?.users || []);
            const ativos = lista.filter(x => x.ativo).length;
            const bloq = lista.length - ativos;
            return `Logins. ${ativos} ativos${bloq ? `, ${bloq} bloqueados` : ''}.`;
        }
        if (pathname === '/Crontab') {
            const r = await ConsultaRotinas({});
            const lista = Array.isArray(r) ? r : (r?.rotinas || []);
            const ativas = lista.filter(x => x.ativo !== false).length;
            const pausadas = lista.length - ativas;
            const falhas = lista.filter(x => x.ultima_execucao && x.ultima_execucao.erro).length;
            return `Crontab. ${lista.length} rotinas${ativas ? `, ${ativas} ativas` : ''}${pausadas ? `, ${pausadas} pausadas` : ''}${falhas ? `, ${falhas} com falha recente` : ''}.`;
        }
        if (pathname === '/Internas') {
            const r = await ConsultaInternas({});
            const lista = Array.isArray(r) ? r : (r?.telas || r?.internas || []);
            const built = lista.filter(x => x.tipo === 'built' || x.origem === 'construtor').length;
            const estaticas = lista.length - built;
            return `Páginas internas. ${lista.length} no total${built ? `, ${built} do construtor` : ''}${estaticas ? `, ${estaticas} estáticas` : ''}.`;
        }
        if (pathname === '/Logs') {
            const r = await ConsultaLogs({});
            const lista = Array.isArray(r) ? r : (r?.eventos || r?.linhas || []);
            return `Logs e histórico. ${lista.length} eventos carregados.`;
        }
        if (pathname === '/Arquivos') {
            const r = await ConsultaArquivos({});
            const sv = r?.servidores || r?.shares || (Array.isArray(r) ? r : []);
            return `Acesso a arquivos. ${sv.length} servidor${sv.length === 1 ? '' : 'es'} disponível${sv.length === 1 ? '' : 'eis'}.`;
        }
        if (pathname === '/TI/Permissoes') {
            const r = await ConsultaPermissoes({});
            const matriz = r?.matriz || {};
            const setores = Object.keys(matriz).length;
            return `Permissões. Matriz configurada para ${setores} setor${setores === 1 ? '' : 'es'}.`;
        }
        if (pathname === '/TI/Construtor') {
            const r = await ConsultaConstrutor({});
            const lista = Array.isArray(r) ? r : (r?.telas || []);
            return `Construtor de API. ${lista.length} tela${lista.length === 1 ? '' : 's'} publicada${lista.length === 1 ? '' : 's'}.`;
        }
        if (pathname === '/TI/Telegram') {
            const r = await ConsultaTelegram({});
            const canais = r?.canais || (Array.isArray(r) ? r : []);
            return `Telegram. ${canais.length} canal${canais.length === 1 ? '' : 'is'} configurado${canais.length === 1 ? '' : 's'}.`;
        }
        if (pathname === '/Dashboard') {
            // tenta resumo cruzado: alertas pendentes + ultima latencia
            const [a, m] = await Promise.all([ConsultaAlertas({}), ConsultaMonitor({ limit: 200 })]);
            const ale = Array.isArray(a) ? a.length : 0;
            const erros = Array.isArray(a) ? a.filter(x => x.severidade === 'err').length : 0;
            const s = m?.stats || {};
            return `Dashboard. ${ale} alerta${ale === 1 ? '' : 's'} pendente${ale === 1 ? '' : 's'}${erros ? `, ${erros} crítico${erros === 1 ? '' : 's'}` : ''}. Sistema com ${s.total || 0} chamada${(s.total || 0) === 1 ? '' : 's'} no buffer.`;
        }
        if (pathname === '/Configuracoes') {
            return 'Configurações pessoais. Senha, servidores Samba e assistente de voz.';
        }
    } catch (_) {}
    // fallback: so nome da tela
    const nome = LABEL_ROTA[pathname];
    if (nome) return `Você está em ${nome}.`;
    return '';
}

// =============================================================================
// ICONE JARVIS
// =============================================================================
function IconeJarvis({ size = 28, ativo = false, falando = false }) {
    return (
        <svg width={size} height={size} viewBox="0 0 64 64" style={{ display:'block' }}>
            <defs>
                <radialGradient id="cb-jarvis-grad" cx="50%" cy="50%" r="50%">
                    <stop offset="0%"   stopColor="#000"/>
                    <stop offset="60%"  stopColor="#000"/>
                    <stop offset="100%" stopColor="rgba(255,255,255,0.15)"/>
                </radialGradient>
            </defs>
            <circle cx="32" cy="32" r="30" fill="none" stroke="rgba(255,255,255,0.15)" strokeDasharray="1 3"/>
            <circle cx="32" cy="32" r="26" fill="none" stroke="rgba(255,255,255,0.7)" strokeWidth="1"/>
            <circle cx="32" cy="32" r="22" fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="0.8"/>
            <circle cx="32" cy="32" r="9" fill="url(#cb-jarvis-grad)" stroke="rgba(255,255,255,0.9)" strokeWidth="1.2"/>
            {[ [32,3], [61,32], [32,61], [3,32] ].map(([x,y],i) => (
                <g key={i} stroke="#fff" strokeWidth="1.2">
                    <line x1={x-3} y1={y} x2={x+3} y2={y}/>
                    <line x1={x} y1={y-3} x2={x} y2={y+3}/>
                </g>
            ))}
            {[ [50,14], [14,14], [50,50], [14,50] ].map(([x,y],i) => (
                <circle key={i} cx={x} cy={y} r="1.6" fill="#fff" stroke="rgba(255,255,255,0.7)"/>
            ))}
            <circle cx="32" cy="32" r="2.2" fill="#fff" opacity={ativo ? 0.95 : 0.7}>
                {ativo && <animate attributeName="opacity" values="0.4;1;0.4" dur="1.1s" repeatCount="indefinite"/>}
            </circle>
            {falando && (
                <>
                    <circle cx="32" cy="32" r="14" fill="none" stroke="#7fdbff" strokeWidth="0.8" opacity="0.7">
                        <animate attributeName="r" values="14;17;14" dur="0.8s" repeatCount="indefinite"/>
                        <animate attributeName="opacity" values="0.7;0.2;0.7" dur="0.8s" repeatCount="indefinite"/>
                    </circle>
                    <circle cx="32" cy="32" r="18" fill="none" stroke="#7fdbff" strokeWidth="0.6" opacity="0.5">
                        <animate attributeName="r" values="18;21;18" dur="1.0s" begin="0.2s" repeatCount="indefinite"/>
                        <animate attributeName="opacity" values="0.5;0.1;0.5" dur="1.0s" begin="0.2s" repeatCount="indefinite"/>
                    </circle>
                </>
            )}
        </svg>
    );
}

export default function AssistenteVoz() {
    const navigate = useNavigate();
    const location = useLocation();
    const [ativo, setAtivo] = useState(vozAtiva());
    const [ouvindo, setOuvindo] = useState(false);
    const [texto, setTexto] = useState('');
    const [resposta, setResposta] = useState('');
    const [aberto, setAberto] = useState(false);
    const [falando, setFalando] = useState(false);
    const [opcoesBabito, setOpcoesBabito] = useState([]);
    const [entrada, setEntrada] = useState('');
    const recRef = useRef(null);
    const ultimoAlertaRef = useRef(null);
    const ultimaRotinaRef = useRef(null);
    const ultPathRef = useRef(null);

    useEffect(() => {
        function on() { setAtivo(vozAtiva()); }
        window.addEventListener('storage', on);
        window.addEventListener('centralbabita:voz-toggle', on);
        return () => {
            window.removeEventListener('storage', on);
            window.removeEventListener('centralbabita:voz-toggle', on);
        };
    }, []);

    // iter9.5: estado "falando" sincronizado com a fila singleton (voz.js -> vozBus)
    useEffect(() => {
        if (!vozBus) return;
        const onIni = () => setFalando(true);
        const onFim = () => setFalando(false);
        vozBus.addEventListener('inicio', onIni);
        vozBus.addEventListener('fim', onFim);
        return () => {
            vozBus.removeEventListener('inicio', onIni);
            vozBus.removeEventListener('fim', onFim);
        };
    }, []);

    // RESUMO AO NAVEGAR
    useEffect(() => {
        if (!ativo || !resumosAtivos()) { ultPathRef.current = location.pathname; return; }
        // primeira tela = baseline (nao fala no mount)
        if (ultPathRef.current === null) { ultPathRef.current = location.pathname; return; }
        if (ultPathRef.current === location.pathname) return;
        ultPathRef.current = location.pathname;
        resumoDe(location.pathname).then(t => t && falar(t));
    }, [ativo, location.pathname]);

    // PANORAMA DE BOAS-VINDAS — Cadu fala um resumo ao abrir o sistema (1x por sessao)
    useEffect(() => {
        // Panorama de boas-vindas: fala 1x ao montar (apos login). Fala mesmo com o FAB
        // de voz desativado. Sem sessionStorage (que travava o relogin na mesma aba).
        // Autoplay: se a pagina ja teve interacao (ex: clique no login) toca direto;
        // senao (ex: reload) fala no 1o gesto do usuario.
        let cancel = false;
        const limpadores = [];
        (async () => {
            try {
                const u = JSON.parse(localStorage.getItem('centralbabita.user') || 'null');
                if (!u) return;
                const r = await MontaPanorama({ user_id: u.id, nome: u.nome });
                if (cancel || !r || !r.texto) return;
                let disparado = false;
                const dizer = () => { if (disparado || cancel) return; disparado = true; try { falar(r.texto); } catch (_) {} };
                const ua = (typeof navigator !== 'undefined') ? navigator.userActivation : null;
                if (ua && ua.hasBeenActive) {
                    dizer();
                } else {
                    ['pointerdown', 'keydown', 'click', 'touchstart'].forEach(ev => {
                        const fn = () => dizer();
                        window.addEventListener(ev, fn, { once: true });
                        limpadores.push(() => { try { window.removeEventListener(ev, fn); } catch (_) {} });
                    });
                }
            } catch (_) {}
        })();
        return () => { cancel = true; limpadores.forEach(f => f()); };
    }, []);

    // Polling de eventos -> fala via Piper
    useEffect(() => {
        if (!ativo) return;
        let alive = true;
        let primeira = true;
        async function verificar() {
            if (!avisosAtivos()) return;
            try {
                const alerts = await ConsultaAlertas({});
                if (Array.isArray(alerts) && alerts.length) {
                    const ids = new Set(alerts.map(a => a.id));
                    if (!primeira && ultimoAlertaRef.current) {
                        const novos = alerts.filter(a => !ultimoAlertaRef.current.has(a.id));
                        if (novos.length) {
                            const a = novos[0];
                            const titulo = (a.titulo || a.mensagem || '').slice(0, 120);
                            falar(novos.length === 1
                                ? `Atenção: novo alerta. ${titulo}.`
                                : `Atenção: ${novos.length} novos alertas. O primeiro: ${titulo}.`);
                        }
                    }
                    ultimoAlertaRef.current = ids;
                }
                const mon = await ConsultaMonitor({ limit: 50 });
                if (mon && Array.isArray(mon.eventos)) {
                    const rotinas = mon.eventos.filter(e => e.path === '/ExecutaRotina' || e.path === '/scheduler-tick');
                    if (!primeira && ultimaRotinaRef.current && rotinas.length) {
                        const novos = rotinas.filter(e => e.id > ultimaRotinaRef.current);
                        for (const e of novos.slice(-3)) {
                            const nome = e.payload?.nome || e.payload?.id || 'rotina';
                            await falar(e.erro || e.status >= 400 ? `Rotina ${nome} falhou.` : `Rotina ${nome} concluída.`);
                        }
                    }
                    if (rotinas.length) ultimaRotinaRef.current = Math.max(...rotinas.map(e => e.id));
                }
            } catch (_) {}
            primeira = false;
        }
        verificar();
        const id = setInterval(() => { if (alive) verificar(); }, 30_000);
        return () => { alive = false; clearInterval(id); };
    }, [ativo]);

    async function processarComando(t) {
        setOpcoesBabito([]);
        const corrigido = aplicaDicionario(t);
        const cmd = corrigido.trim().toLowerCase().replace(/[.!?,]/g, '');

        // 1) PERGUNTAS habilitadas
        const handler = matchPergunta(cmd);
        if (handler) {
            const r = await handler();
            return r || 'Sem resposta.';
        }

        // 2) busca
        const mBuscar = cmd.match(/^(buscar|pesquisar|procurar|busca|pesquise|procure)\s+(.+)/);
        if (mBuscar) {
            const termo = mBuscar[2];
            const input = document.querySelector('.topbar .search input');
            if (input) {
                input.focus();
                const proto = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
                proto.set.call(input, termo);
                input.dispatchEvent(new Event('input', { bubbles: true }));
                input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', bubbles: true }));
            }
            return `Buscando "${termo}".`;
        }
        // 3) rotas - apos navegar, fala o resumo da tela (numeros reais) em vez do generico "Abrindo X".
        // O dedupe de 5s no voz.js evita dupla-fala caso o toggle "resumo ao mudar de tela" tambem
        // tente disparar o mesmo texto via useEffect.
        for (const r of ROTAS) {
            if (r.regex.test(cmd)) {
                navigate(r.to);
                const resumo = await resumoDe(r.to);
                return resumo || `Abrindo ${r.label}.`;
            }
        }
        // 4) sair
        if (/^(sair|logout|desconectar|fazer logout)/i.test(cmd)) {
            const btnSair = document.querySelector('.sidebar-logout');
            if (btnSair) { btnSair.click(); return 'Saindo.'; }
        }
        // 5) Pergunte pro Babito — cai no catalogo de "Perguntar aos Dados" (mesma busca da tela).
        const u5 = usuarioAtual();
        if (u5 && u5.email) {
            try {
                const rB = await PD_Buscar({ solicitante: u5.email, pergunta: corrigido.trim() });
                if (rB && !rB.Error) {
                    if (rB.mensagem) return rB.mensagem;
                    const opcoes = (rB.resultados || []).slice(0, 5);
                    if (opcoes.length) {
                        setOpcoesBabito(opcoes.map(o => ({ id: o.id, titulo: o.titulo, resposta_curta: o.resposta_curta, pergunta: corrigido.trim() })));
                        setAberto(true);
                        return opcoes.length === 1
                            ? `Encontrei uma opção: ${opcoes[0].titulo}. Selecione pra eu responder.`
                            : `Encontrei ${opcoes.length} opções pro que você perguntou. Selecione uma.`;
                    }
                }
            } catch (_) { /* segue pro fallback generico */ }
        }
        // TODO(iter10): fallback p/ LLM. Ver docs/ASSISTENTE_VOZ.md.
        return 'Ainda não sei responder isso. Tente uma das sugestões prontas no botão de interrogação.';
    }

    async function executarOpcaoBabito(item, confirmar) {
        destravarAudioMobile();
        setOpcoesBabito([]);
        const u = usuarioAtual();
        const r = await PD_Executar({ solicitante: u ? u.email : null, id: item.id, pergunta: item.pergunta, confirmarPesada: !!confirmar });
        if (r && r.needsConfirm) {
            // NAO sobrescreve item.titulo (fica so no _label do chip) -- senao a resposta final,
            // quando confirmada, herdava o prefixo "Confirmar - " no texto falado/mostrado.
            setOpcoesBabito([{ id: item.id, pergunta: item.pergunta, titulo: item.titulo, _confirmar: true, _label: 'Confirmar — ' + item.titulo }]);
            const t = r.aviso || 'Essa consulta pode demorar. Quer confirmar?';
            setResposta(t); falar(t);
            return;
        }
        const t = resumirResultadoParaFala(r, item.titulo);
        setResposta(t); falar(t);
    }

    async function executar(cmd) {
        destravarAudioMobile();
        setTexto(cmd);
        const r = await processarComando(cmd);
        setResposta(r);
        falar(r);
    }

    function enviarTexto() {
        const t = entrada.trim();
        if (!t) return;
        setEntrada('');
        executar(t);
    }

    function iniciar() {
        destravarAudioMobile();
        if (!SpeechRec) {
            // Sem reconhecimento de voz (ex.: iPhone/Safari nao suporta) -- antes ficava tudo
            // fechado e mudo. Agora abre o painel: da pra digitar a pergunta e tocar sugestoes.
            const m = 'Reconhecimento de voz não é suportado neste navegador. Digite sua pergunta ou toque numa sugestão.';
            setTexto(''); setResposta(m); setOpcoesBabito([]); setAberto(true);
            falar(m);
            return;
        }
        try {
            const rec = new SpeechRec();
            rec.lang = 'pt-BR';
            rec.interimResults = true;
            rec.continuous = false;
            recRef.current = rec;
            setTexto(''); setResposta(''); setOpcoesBabito([]); setAberto(true);
            setOuvindo(true);
            rec.onresult = async (ev) => {
                let txt = '';
                for (let i = ev.resultIndex; i < ev.results.length; i++) txt += ev.results[i][0].transcript;
                setTexto(txt);
                if (ev.results[ev.results.length - 1].isFinal) {
                    const r = await processarComando(txt);
                    setResposta(r);
                    falar(r);
                }
            };
            rec.onerror = (e) => {
                setOuvindo(false);
                if (e.error === 'not-allowed') setResposta('Permissão de microfone negada.');
                else if (e.error === 'no-speech') setResposta('Não captei sua voz. Tente novamente.');
                else setResposta('Erro: ' + e.error);
            };
            rec.onend = () => setOuvindo(false);
            rec.start();
        } catch (e) {
            setOuvindo(false);
            setResposta('Falha ao iniciar: ' + (e.message || e));
        }
    }
    function parar() {
        try { recRef.current && recRef.current.stop(); } catch (_) {}
        setOuvindo(false);
        silenciar();
    }
    function fecharPainel() {
        setTexto(''); setResposta(''); setOpcoesBabito([]); setAberto(false);
        // NAO chama parar() — fechar o popover nao deve cortar a fala em curso.
        // Para parar a fala, o usuario clica no botao principal (microfone) ou desativa em /Configuracoes.
    }

    if (!ativo) return null;
    if (SEM_BOTAO.some(p => location.pathname.startsWith(p))) return null;
    const gruposSugestoes = Array.from(new Set(SUGESTOES.map(s => s.grupo)));

    return (
        <>
            {aberto && (
                <div style={{
                    position:'fixed', right:24, bottom:96, zIndex:9999,
                    background:'#000', color:'#fff',
                    border:'1px solid rgba(255,255,255,0.3)',
                    boxShadow:'0 8px 32px -16px rgba(0,0,0,.7), 0 0 24px rgba(255,255,255,0.05)',
                    padding:'14px 16px', width:'min(360px, calc(100vw - 48px))', fontSize:13, maxHeight:'70vh', overflow:'auto',
                    fontFamily:'ui-monospace, "JetBrains Mono", monospace'
                }}>
                    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
                        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                            <IconeJarvis size={20} ativo={ouvindo} falando={falando}/>
                            <span style={{ fontSize:10, letterSpacing:'.22em', textTransform:'uppercase', color:'rgba(255,255,255,0.7)' }}>Babita · Voz Cadu</span>
                        </div>
                        <button onClick={fecharPainel} style={{ background:'transparent', border:0, cursor:'pointer', color:'rgba(255,255,255,0.5)', fontSize:18 }}>×</button>
                    </div>
                    <div style={{ display:'flex', gap:6, marginBottom:10 }}>
                        <input
                            type="text"
                            value={entrada}
                            onChange={e => setEntrada(e.target.value)}
                            onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); enviarTexto(); } }}
                            placeholder="Digite sua pergunta…"
                            style={{ flex:1, minWidth:0, background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.25)', color:'#fff', padding:'6px 8px', fontSize:12, fontFamily:'inherit' }}
                        />
                        <button onClick={enviarTexto} style={{ fontSize:11, padding:'6px 10px', border:'1px solid rgba(255,255,255,0.25)', background:'rgba(255,255,255,0.08)', color:'#fff', cursor:'pointer', fontFamily:'inherit', flexShrink:0 }}>Enviar</button>
                    </div>
                    {texto && (
                        <div style={{ marginBottom:8, fontSize:12, color:'#fff', wordBreak:'break-word' }}>
                            <span style={{ color:'rgba(255,255,255,0.5)' }}>você: </span>{texto}
                        </div>
                    )}
                    {resposta && (
                        <div style={{ marginTop:4, padding:'8px 10px', background:'rgba(255,255,255,0.06)', borderLeft:'2px solid #fff', fontSize:12, marginBottom:10 }}>
                            {resposta}
                        </div>
                    )}
                    {opcoesBabito.length > 0 && (
                        <div style={{ marginBottom:10 }}>
                            <div style={{ fontSize:9.5, marginBottom:6, opacity:0.7, letterSpacing:'.18em', textTransform:'uppercase' }}>Pergunte pro Babito · escolha uma opção</div>
                            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                                {opcoesBabito.map(op => (
                                    <button
                                        key={op.id}
                                        onClick={() => executarOpcaoBabito(op, op._confirmar)}
                                        title={op.resposta_curta || ''}
                                        style={{
                                            textAlign:'left', fontSize:11, padding:'6px 9px',
                                            border:'1px solid rgba(255,255,255,0.25)',
                                            background:'rgba(255,255,255,0.08)',
                                            color:'#fff', cursor:'pointer', fontFamily:'inherit'
                                        }}
                                    >
                                        {op._label || op.titulo}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                    <div style={{ marginTop:6 }}>
                        {gruposSugestoes.map(g => (
                            <div key={g} style={{ marginBottom:10 }}>
                                <div style={{ fontSize:9.5, marginBottom:6, opacity:0.7, letterSpacing:'.18em', textTransform:'uppercase' }}>{g}</div>
                                <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
                                    {SUGESTOES.filter(s => s.grupo === g).map(s => (
                                        <button
                                            key={s.label}
                                            onClick={() => executar(s.cmd)}
                                            style={{
                                                fontSize:11, padding:'4px 9px',
                                                border:'1px solid rgba(255,255,255,0.25)',
                                                background:'rgba(255,255,255,0.08)',
                                                color:'#fff',
                                                cursor:'pointer',
                                                fontFamily:'inherit'
                                            }}
                                            title={`Executar: ${s.cmd}`}
                                        >
                                            {s.label}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div data-no-capture style={{ position:'fixed', right:24, bottom:24, zIndex:9999, display:'flex', flexDirection:'column', gap:10, alignItems:'flex-end' }}>
                <button
                    type="button"
                    onClick={() => ouvindo ? parar() : iniciar()}
                    aria-label="Assistente de voz Babita"
                    title={!SpeechRec ? 'Perguntar ao Babita (digite)' : (ouvindo ? 'Parar gravação' : 'Falar (clique e diga um comando)')}
                    style={{
                        width:60, height:60, borderRadius:'50%',
                        background:'#000', color:'#fff', border:`1.5px solid ${ouvindo ? '#c0392b' : 'rgba(255,255,255,0.9)'}`,
                        boxShadow: ouvindo
                            ? '0 0 18px rgba(192,57,43,0.55), 0 0 40px rgba(192,57,43,0.25)'
                            : falando
                                ? '0 0 22px rgba(0,0,0,0.65), 0 0 48px rgba(0,0,0,0.35), inset 0 0 14px rgba(255,255,255,0.10)'
                                : '0 0 18px rgba(255,255,255,0.35), 0 0 40px rgba(255,255,255,0.15), inset 0 0 14px rgba(255,255,255,0.06)',
                        cursor:'pointer', display:'grid', placeItems:'center',
                        transition:'box-shadow .2s, transform .15s, border-color .2s',
                        animation: falando ? 'centralbabita-respira 1.1s ease-in-out infinite' : 'none',
                        position:'relative'
                    }}
                    onMouseDown={(e) => e.currentTarget.style.transform='scale(0.95)'}
                    onMouseUp={(e)   => e.currentTarget.style.transform='scale(1)'}
                    onMouseLeave={(e)=> e.currentTarget.style.transform='scale(1)'}
                    onContextMenu={(e) => { e.preventDefault(); setAberto(v => !v); }}
                >
                    <IconeJarvis size={36} ativo={ouvindo} falando={falando}/>
                    {ouvindo && (
                        <span style={{
                            position:'absolute', inset:-8, borderRadius:'50%',
                            border:'2px solid #c0392b', opacity:.55,
                            animation:'centralbabita-pulse 1.3s ease-out infinite', pointerEvents:'none'
                        }}/>
                    )}
                    {!ouvindo && falando && (
                        <span style={{
                            position:'absolute', inset:-8, borderRadius:'50%',
                            border:'2px solid rgba(255,255,255,0.85)', opacity:.6,
                            animation:'centralbabita-pulse-falando 1.1s ease-out infinite', pointerEvents:'none'
                        }}/>
                    )}
                </button>
            </div>
            <style>{`
                @keyframes centralbabita-pulse {
                    0%   { transform: scale(1);   opacity:.55; }
                    100% { transform: scale(1.5); opacity:0;   }
                }
                @keyframes centralbabita-respira {
                    0%, 100% { transform: scale(1);    box-shadow: 0 0 22px rgba(0,0,0,0.6); }
                    50%      { transform: scale(1.06); box-shadow: 0 0 32px rgba(0,0,0,0.85); }
                }
                @keyframes centralbabita-pulse-falando {
                    0%   { transform: scale(1);   opacity:.45; }
                    100% { transform: scale(1.55); opacity:0;  }
                }
            `}</style>
        </>
    );
}
